type AnalyticsEvent = 'search' | 'club_selected' | 'team_selected' | 'location_selected' | 'filter_used' | 'join_clicked' | 'futwork_cta_clicked';

/**
 * Tracks events for the Find Your Club feature
 * Logs to console and stores in localStorage for admin review
 */
export function trackFindClubEvent(
  event: AnalyticsEvent,
  data: Record<string, any>
): void {
  // Log to console for development
  console.log('[Analytics]', event, data);
  
  try {
    // Store in localStorage for admin review
    const events = JSON.parse(localStorage.getItem('club_finder_events') || '[]');
    events.push({ 
      event, 
      data, 
      timestamp: new Date().toISOString() 
    });
    
    // Keep only last 100 events
    const limitedEvents = events.slice(-100);
    localStorage.setItem('club_finder_events', JSON.stringify(limitedEvents));
  } catch (error) {
    console.error('Error storing analytics event:', error);
  }
}
